import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.YEARBOOK;

export const IS_INTERMEDIATE_SAVING_DISABLED = false;

export const AVAILABLE_LEVEL_INDEXES = [0, 1, 2, 3];
export const MIN_TRIES_FOR_MASTERY = 2;
export const MAX_WRONG_TRIES = 3;
export const ITEMS_FAILED_COUNT_FOR_LEVEL_FAIL = 3;

export const NUM_QUESTIONS = 12;
export const MIN_MASTERED_ITEMS_TO_BEAT_LEVEL = 10;

export const INFERENCE_ANIMATION_DURATION = 400;
export const WRONG_FEEDBACK_DURATION = 2000;
export const SCROLLVIEW_HEIGHT = 495;

// increment this value if you need to change the shape of a user's save data
// in a way that will invalidate previous data.
// the saveDataReducer will automatically ignore any save data with a version lower than this value.
export const CURRENT_SAVE_DATA_VERSION = 2;

// Game screens
export const SCREENS = {
  INTRODUCTION: 'INTRODUCTION',
  PROGRESS: 'PROGRESS',
  STANDARD: 'STANDARD',
  LOADING: 'LOADING',
  ONBOARDING: 'ONBOARDING',
  REPEAT_ONBOARDING: 'REPEAT_ONBOARDING',
  YEARBOOK: 'YEARBOOK',
  TRY_AGAIN: 'TRY_AGAIN',
};

export const YEARBOOK_SCREEN_SIDEBARS = {
  NONE: 'NONE',
  SUPERLATIVES: 'SUPERLATIVES',
  DOCUMENTS: 'DOCUMENTS',
};

export const SUPERLATIVE_SIDEBAR_WIDTH = 422;
export const DOCUMENTS_SIDEBAR_WIDTH = 244 + 90; // Width of sidebar + empty space from wireframes
export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  INITIALIZE_LEVEL: 'INITIALIZE_LEVEL',
  INITIALIZE_STANDARD_ITEM: 'INITIALIZE_STANDARD_ITEM',
  COMPLETE_ONBOARDING: 'COMPLETE_ONBOARDING',
  SET_LEVEL_INDEX: 'SET_LEVEL_INDEX',
  COMPLETE_INTRODUCTION: 'COMPLETE_INTRODUCTION',

  SELECT_CHARACTER: 'SELECT_CHARACTER',
  DESELECT_CHARACTER: 'DESELECT_CHARACTER',
  SUBMIT_SUPERLATIVE: 'SUBMIT_SUPERLATIVE',

  REGISTER_TAGGABLE_WORD_LAYOUT: 'REGISTER_TAGGABLE_WORD_LAYOUT',
  SET_SELECTED_INFERENCE_INDEX: 'SET_SELECTED_INFERENCE_INDEX',
  TOGGLE_EVIDENCE_SELECTION: 'TOGGLE_EVIDENCE_SELECTION',
  DESELECT_INFERENCE: 'DESELECT_INFERENCE',
  DESELECT_EVIDENCE: 'DESELECT_EVIDENCE',
  DISABLE_EVIDENCE: 'DISABLE_EVIDENCE',
  SET_IS_INFERENCE_PANEL_DISCARDING: 'SET_IS_INFERENCE_PANEL_DISCARDING',
  SET_IS_EVIDENCE_PANEL_SHAKING: 'SET_IS_EVIDENCE_PANEL_SHAKING',
  DISCARD_SELECTED_INFERENCE_CHOICE: 'DISCARD_SELECTED_INFERENCE_CHOICE',
  SHOW_HELP_TEXT: 'SHOW_HELP_TEXT',
  HIDE_HELP_TEXT: 'HIDE_HELP_TEXT',
  EXPAND_HELP_PANEL: 'EXPAND_HELP_PANEL',
  SELECT_DOCUMENT: 'SELECT_DOCUMENT',

  SET_CURRENT_VO_NAME: 'SET_CURRENT_VO_NAME',
  STOP_VO_PLAYBACK: 'STOP_VO_PLAYBACK',
  ON_VO_ENDS: 'ON_VO_ENDS',
  COMPLETE_STD_ITEM: 'COMPLETE_STD_ITEM',
  INCREMENT_WRONG_COUNT: 'INCREMENT_WRONG_COUNT',
  FAIL_STD_ITEM: 'FAIL_STD_ITEM',

  TRIGGER_HELP_VO: 'TRIGGER_HELP_VO',
  REPEAT_ONBOARDING: 'REPEAT_ONBOARDING',
  MASTER_LEVEL: 'MASTER_LEVEL',
  MERGE_GAME_STATE: 'MERGE_GAME_STATE',
  SET_SAVED_GAME_STATE: 'SET_SAVED_GAME_STATE',
  UPDATE_RECORDS: 'UPDATE_RECORDS',
};

export const VO_NAMES = {
  selectAPictureTo: 'selectAPictureTo',
  thisYearbookIsReally: 'thisYearbookIsReally',
  findCharacterTraits: 'findCharacterTraits',
  excellentLetsSelect: 'excellentLetsSelect',
  whichOfTheSuperlatives: 'whichOfTheSuperlatives',
  toSupportYour: 'toSupportYour',
  hereIsTheInformation: 'hereIsTheInformation',
  tapOnAnyDocument: 'tapOnAnyDocument',
  whyDoYouThink: 'whyDoYouThink',
  tagGreat: 'tagGreat',
  heyThereWelcomeTo: 'heyThereWelcomeTo',
  aYearbookHasPictures: 'aYearbookHasPictures',
  itsAGreatHonor: 'itsAGreatHonor',
  welcomeBackTo: 'welcomeBackTo',
  greatLetsGetTo: 'greatLetsGetTo',
  aBitMore: 'aBitMore',
  greatWorkThisYearbook: 'greatWorkThisYearbook',
  incorrectTrait: 'incorrectTrait',
  incorrectTraitAndEvidence: 'incorrectTraitAndEvidence',
  incorrectEvidence: 'incorrectEvidence',
  whichTraitsDoYou: 'whichTraitsDoYou',
  inThisDocument: 'inThisDocument',
  ifYouNeedTo: 'ifYouNeedTo',
  agreesWithYou: 'agreesWithYou',
  greatIfYouNeed: 'greatIfYouNeed',
  greatLetsGetToKnow: 'greatLetsGetToKnow',
  notQuite: 'notQuite',
};
